import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import { useContext } from "react";
import TabelaRedux from "../../contexts/Tabela";
import CustomButtonV2 from "../CustomButtonV2/CustomButtonV2";
import "../ModalUsuario/ModalUsuario.css";

export interface SimpleDialogProps {
	titulo: string;
	tituloBotao?: string;
	tituloConfirmar?: string;
	texto?: string;
	dataAlteracao?: string;
	open: boolean;
	onClose: () => void;
	onClick?: () => void;
}

function ModalUsuario(props: SimpleDialogProps) {
	const { tabelaRedux } = useContext(TabelaRedux);

	const { onClose, open } = props;

	const handleClose = () => {
		onClose();
	};

	const handleClick = () => {
		onClose();
	};

	const data = tabelaRedux.dataAlteracao;
	const formatDate = (data) => {
		return new Date(data).toLocaleDateString("pt-BR", {
			year: "numeric",
			month: "numeric",
			day: "numeric",
			hour: "2-digit",
			minute: "2-digit",
			second: "2-digit",
		});
	};

	return (
		<div>
			<Dialog open={open} onClose={handleClose}>
				<div className="div-modal-usuario">
					<DialogTitle id="alert-dialog-title">{props.titulo}</DialogTitle>
					<DialogContent>
						<DialogContentText id="alert-dialog-description">
							{!tabelaRedux.dataAlteracao ? (
								<b className="user">{tabelaRedux.usuarioAlteracao}</b>
							) : (
								<span className="usuario-data">
									<b className="user">Nome: {tabelaRedux.usuarioAlteracao}</b>
									<b className="user">Data Alteração: {formatDate(data)}</b>
								</span>
							)}
						</DialogContentText>
					</DialogContent>
					<DialogActions>
						<CustomButtonV2
							classCss="custom-button-cadastrar"
							classText="button-texto-cadastrar"
							titulo="OK"
							cor="#0946B8"
							onClick={handleClick}
						/>
					</DialogActions>
				</div>
			</Dialog>
		</div>
	);
}

export default ModalUsuario;
